import { render, staticRenderFns } from "./personalizedFaq.vue?vue&type=template&id=081fba17&scoped=true&"
import script from "./personalizedFaq.vue?vue&type=script&lang=js&"
export * from "./personalizedFaq.vue?vue&type=script&lang=js&"
import style0 from "./personalizedFaq.vue?vue&type=style&index=0&id=081fba17&scoped=true&lang=css&"
import style1 from "./personalizedFaq.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081fba17",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
